<!-- 由 suu 创建于 2022-01-08 星期六 -->
<template>
  <div class="ItemMealAbnormal">
    <div class="ima-item" v-for="(item, index) in info" :key="index">
      <div class="i-title">
        <van-icon name="warning-o" />
        <div class="t-cent">{{ item.title }}</div>
        <div
          class="t-btn"
          @click="handelSwitchMore(index)"
          v-if="item.list.length"
        >
          {{ item.more ? '收起' : '展开' }}
          <van-icon :name="'arrow-' + (item.more ? 'up' : 'down')" />
        </div>
      </div>
      <div class="i-desc" v-if="item.more">
        {{ item.list.join('、') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemMealAbnormal',

  components: {},

  props: {
    info: {}
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    handelSwitchMore(index) {
      let cur = this.info[index]
      cur['more'] = !cur['more']
      this.$set(this.info, index, cur)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ItemMealAbnormal {
  width: 100%;
  box-sizing: border-box;
  margin-top: 10px;
  background: #f7f7f7;
  border-radius: 6px;
  border: 1px solid #f1f1f1;
  padding: 12px 16px;
  .ima-item {
    width: 100%;
    box-sizing: border-box;
    .i-title {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      i.van-icon-warning-o {
        font-size: 14px;
        color: #2882e9;
      }
      .t-cent {
        flex: 1;
        margin-left: 7px;
        font-size: 13px;
      }
      .t-btn {
        font-size: 13px;
        font-weight: 500;
        color: #2882e9;
        i {
          font-size: 10px;
        }
      }
    }
    .i-desc {
      font-size: 12px;
      font-weight: 500;
      line-height: 20px;
      margin-top: 12px;
      width: 100%;
      box-sizing: border-box;
      padding-left: 20px;
      word-break: break-all;
    }
    & + .ima-item {
      margin-top: 12px;
      padding-top: 12px;
      border-top: 1px solid #f1f1f1;
    }
  }
}
</style>
